import React, { Component } from 'react';
import {connect} from 'react-redux';

import {facebookShare, twitterShare} from '../../../utils/utils'

import './../../../../scss/App.scss';

import AccAccessBtnContainer from '../../../containers/AccAccessBtnContainer';
import { trackingWrapper } from '../../../utils/analytics';
import FooterLogo from '../../FooterLogo';

class Header extends Component {

	constructor(props){
		super(props);

		this.transitionIn = new window.TimelineMax({
									onComplete : this.handleTransitionComplete,
									onCompleteParams:[this],
									onReverseComplete:this.handleTransitionOutComplete, 
									onReverseCompleteParams:[this]});

		this.state = {
			inTransition : false
		}

		this.playBtnHandleOnClick = this.playBtnHandleOnClick.bind(this);
		this.facebookHandleClick = this.facebookHandleClick.bind(this);
		this.twitterHandleClick = this.twitterHandleClick.bind(this);

		this.accAccessBtn = React.createRef();
	}

	componentDidMount(){
		window.TweenMax.set(this.refs.wipe, {"height":"100%"});
		window.TweenMax.set(this.refs.host, {"height":"0%"});
		window.TweenMax.set(this.refs.logo, {"opacity":0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.refs.playBtn, {"opacity":0, "transform":"translateY(1vw)"});
		window.TweenMax.set(this.accAccessBtn.current, {"opacity":0, "transform":"translateY(1vw)"});

		this.transitionIn.to(this.refs.wipe, .7, {"height": "0%"})
			.to(this.refs.host, .6, {"height": "100%"})
			.to(this.refs.logo, .6, {"opacity":1, "transform":"translateY(0vw)"}, "-=.4")
			.to(this.refs.playBtn, .6, {"opacity":1, "transform":"translateY(0vw)"}, "-=.2")
			.to(this.accAccessBtn.current, .6, {"opacity":1, "transform":"translateY(0vw)"}, "-=.2")


		this.setState({
			inTransition : true
		});
	}

	playBtnHandleOnClick(){
		if (!this.props.rewardVideo.adBlocked) {
			window.sounds.buttonClick.play();
			
			// tell parent to transition out the ranking and leaderboard modules
			this.props.handleTransitionOut();
			
			// start transition out for this module
			this.transitionIn.reverse(1);
			
			// tracking
			trackingWrapper('event', 'ASgame-game-start', {'event_category':'america-says-game'});
		}
	}

	handleTransitionComplete(_this){
		_this.setState({
			inTransition : false
		});
	}

	handleTransitionOutComplete(_this){
		_this.props.showPage("game");
	}

	facebookHandleClick(){
		trackingWrapper('event', 'ASgame-share-fb', {'event_category':'america-says-game', 'event_label':'landing'});

		//

		const appId = "";
		const shareImage = "http://lifeislikeadot.com/contents_index/comingsoon1.jpg";
		const shareURL = "http://lifeislikeadot.com";
		const shareMsg = "test share messsage";
		const shareRedirectURI = "";

		facebookShare(appId, shareImage, shareURL, shareMsg, shareRedirectURI);
	}

	twitterHandleClick(){
		trackingWrapper('event', 'ASgame-share-tw', {'event_category':'america-says-game', 'event_label':'landing'});

		//
		
		const shareMsg = "test share message";
		const shareURL = "http://lifeislikeadot";

		twitterShare(shareMsg, shareURL);
	}

	render() {
		const hoverActive = (this.state.inTransition) ? "" : "hoverActive";
		const btnRef = this.accAccessBtn;
		let playNowBtnTxt = 'Play Now';

		const {isAppIframed} = this.props;
console.log('Header this.props', this.props);
		const btnClassName = {
			login: 'loginBtn hide',
			logout: 'loginBtn hide',
		}

		const btnLabel = {
			login: 'Login / Register',
			logout: 'Logout',
		}

		if (this.props.rewardVideo.adBlocked) {
			playNowBtnTxt = 'Ad-Blocker Detected';
		}

		return (
			 <div id="header" ref="header" className={hoverActive}>
		 		<div className="logo" ref="logo"></div>
				 <div className="playBtn" ref="playBtn" onClick={() => this.playBtnHandleOnClick()} onMouseOver={() => window.sounds.buttonHover.play()}>{playNowBtnTxt}<span className="fas fa-caret-right"></span></div>
				 <AccAccessBtnContainer 
					 btnLabel = {btnLabel} 
					 btnRef = {btnRef} 
					 btnClassName = {btnClassName}
					/>
				<div className="host" ref="host"></div>
				<FooterLogo />
				{window.config.share && 
		 		<div className="socialWrapper">
		 			<div className="fab fa-facebook-square" onMouseOver={() => window.sounds.buttonHover.play()} onClick={() => this.facebookHandleClick()}></div>
		 			<div className="fab fa-twitter-square" onMouseOver={() => window.sounds.buttonHover.play()} onClick={() => this.twitterHandleClick()}></div>
				</div>
				}
		 		<div className="wipe" ref="wipe"></div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	isAppIframed: state.isAppIframed,
	rewardVideo: state.rewardVideo
});

export default connect(
  mapStateToProps,
)(Header);


// WEBPACK FOOTER //
// ./src/js/components/landingpage/header/Header.js